import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box, Image, Text, VStack } from "@chakra-ui/react";
import Breadcrumb from "../components/Breadcrumb";

const Gibraltar = () => {
  const { t } = useTranslation('navigation');
  const { t: tContent } = useTranslation('gibraltar');
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };

  const images = [
    { src: "/images/gibraltar-zine/VERANOCOLOR-437.jpg", alt: "Gibraltar panoramic view 1" },
    { src: "/images/gibraltar-zine/_DSF1330.jpg", alt: "Gibraltar panoramic view 4" },

        { src: "/images/gibraltar-zine/VERANOCOLOR-444.jpg", alt: "Gibraltar panoramic view 14" },
    { src: "/images/gibraltar-zine/VERANOCOLOR-438.jpg", alt: "Gibraltar panoramic view 2" },
    { src: "/images/gibraltar-zine/_DSF1329.jpg", alt: "Gibraltar panoramic view 13" },

    { src: "/images/gibraltar-zine/VERANOCOLOR-440.jpg", alt: "Gibraltar panoramic view 3" },
    { src: "/images/gibraltar-zine/_DSF1326.jpg", alt: "Gibraltar panoramic view 12" },

    { src: "/images/gibraltar-zine/_DSF1324.jpg", alt: "Gibraltar panoramic view 11" },

    { src: "/images/gibraltar-zine/_DSF1331.jpg", alt: "Gibraltar panoramic view 5" },
    { src: "/images/gibraltar-zine/_DSF1323.jpg", alt: "Gibraltar panoramic view 9" },

    { src: "/images/gibraltar-zine/_DSF1291.jpg", alt: "Gibraltar panoramic view 6" },
    { src: "/images/gibraltar-zine/_DSF1321.jpg", alt: "Gibraltar panoramic view 8" },

    { src: "/images/gibraltar-zine/_DSF1296.jpg", alt: "Gibraltar panoramic view 7" },

  ];

  return (
    <Box
      width="100%"
      paddingTop={{ base: "80px", md: "20px" }}
    >
      {/* Breadcrumb - contained */}
      <Box maxW="1400px" mx="auto" px={{ base: 4, md: 6 }} mb={6}>
        <Breadcrumb
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.zines'), href: getLocalizedPath('/zines') },
            { label: t('breadcrumbs.gibraltar') }
          ]}
        />
      </Box>

      {/* Title and Description - contained */}
      <Box maxW="1400px" mx="auto" px={{ base: 4, md: 6 }} mb={12}>
        <Text fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }} fontWeight="bold" mb={6}>
          {tContent('title')}
        </Text>

        <VStack spacing={4} align="stretch">
          <Text
            textAlign="left"
            fontFamily="Source Code Pro"
            fontSize={{ base: "md", md: "lg" }}
          >
            {tContent('description1')}
          </Text>
          <Text
            textAlign="left"
            fontFamily="Source Code Pro"
            fontSize={{ base: "md", md: "lg" }}
          >
            {tContent('description2')}
          </Text>
        </VStack>
      </Box>

      {/* Images - Full Width */}
      <VStack spacing={{ base: 8, md: 12 }} width="100%">
        {images.map((image, index) => (
          <Box
            key={index}
            width="100%"
            px={{ base: 0, md: 4, lg: 6 }}
          >
            <Image
              src={image.src}
              alt={image.alt}
              width="100%"
              height="auto"
              objectFit="contain"
              loading="lazy"
            />
          </Box>
        ))}
      </VStack>

      {/* Bottom spacing */}
      <Box height={{ base: "40px", md: "60px" }} />
    </Box>
  );
};

export default Gibraltar;
